import { render } from "./left_line2.vue?vue&type=template&id=778e6fb7"
import script from "./left_line2.vue?vue&type=script&lang=js"
export * from "./left_line2.vue?vue&type=script&lang=js"
script.render = render

export default script